module.exports = __webpack_public_path__ + "img/icons8-subaru.554718e5.png";